import React, { useEffect, useState } from "react";

function format(ms) {
    if (ms <= 0) return "expired";
    const s = Math.floor(ms / 1000);
    const d = Math.floor(s / 86400);
    const h = Math.floor((s % 86400) / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;
    if (d > 0) return `${d}d ${h}h`;
    if (h > 0) return `${h}h ${m}m`;
    if (m > 0) return `${m}m ${sec}s`;
    return `${sec}s`;
}

export default function BoostCountdown({ expiresAt, testId }) {
    const target = new Date(expiresAt).getTime();
    const [ms, setMs] = useState(target - Date.now());

    useEffect(() => {
        const t = setInterval(() => setMs(target - Date.now()), 1000);
        return () => clearInterval(t);
    }, [target]);

    return (
        <span className="font-black tabular-nums" data-testid={testId}>
            {format(ms)}
        </span>
    );
}
